export class TilintarkastajaUriService {
  annaTilintarkastajaCollectionUri(): string {
    return 'tilintarkastajat'
  }

  annaTilintarkastajaUri(tilintarkastajaAvain: string): string {
    return this.annaTilintarkastajaCollectionUri() + '/' + tilintarkastajaAvain
  }

  annaTilintarkastajaHistoriaUri(tilintarkastajaAvain: string, historiaAvain: string): string {
    return this.annaTilintarkastajaUri(tilintarkastajaAvain) + '/tilintarkastajat-historia/' + historiaAvain
  }

  annaTilintarkastajaOikeudetCollectionUri(tilintarkastajaAvain: string): string {
    return this.annaTilintarkastajaUri(tilintarkastajaAvain) + '/tilintarkastaja-oikeudet'
  }

  annaTilintarkastajaOikeusUri(tilintarkastajaAvain: string, oikeusAvain: string): string {
    return this.annaTilintarkastajaOikeudetCollectionUri(tilintarkastajaAvain) + '/' + oikeusAvain
  }

  annaTilintarkastajaOikeusHistoriaUri(tilintarkastajaAvain: string, oikeusAvain: string, historiaAvain: string): string {
    return this.annaTilintarkastajaOikeusUri(tilintarkastajaAvain, oikeusAvain) + '/tilintarkastaja-oikeudet-historia/' + historiaAvain
  }

  annaTilintarkastajaKutsutCollectionUri(tilintarkastajaAvain: string): string {
    return this.annaTilintarkastajaUri(tilintarkastajaAvain) + '/tilintarkastaja-kutsut'
  }

  annaTilintarkastajaKutsuUri(tilintarkastajaAvain: string, kutsuAvain: string): string {
    return this.annaTilintarkastajaKutsutCollectionUri(tilintarkastajaAvain) + '/' + kutsuAvain
  }

  annaTilintarkastajaKutsuHistoriaUri(tilintarkastajaAvain: string, kutsuAvain: string, historiaAvain: string): string {
    return this.annaTilintarkastajaKutsuUri(tilintarkastajaAvain, kutsuAvain) + '/tilintarkastaja-kutsut-historia/' + historiaAvain
  }

  annaTilintarkastajaKutsuTyojonoUri(tilintarkastajanAvain: string): string {
    return 'tyojono/tilintarkastajat/tilintarkastaja-laheta-kutsu/' + tilintarkastajanAvain
  }

  annaTilintarkastajaLoginCollectionUri(tilintarkastajaAvain: string): string {
    return this.annaTilintarkastajaUri(tilintarkastajaAvain) + '/tilintarkastaja-logins'
  }

  annaTilintarkastajaLoginUri(tilintarkastajaAvain: string, loginAvain: string): string {
    return this.annaTilintarkastajaLoginCollectionUri(tilintarkastajaAvain) + '/' + loginAvain
  }
}
